import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {withStyles} from '@material-ui/core/styles';

import LoadRegion from '../controls/LoadRegion';
import View from './report/View';

const styles = (theme) => {
    return {
        view: {
            textAlign: 'center',
        },
    };
}

class Report extends Component {
    constructor(props) {
        super(props);

        this.state = {
            regionListTimestamp: 0,
            regionList: [],
        }

        this._loadRegion = new LoadRegion(
            this._handleLoadMapping, this._processError, this.props.getAccessCode, true);

        document.title = 'Report \u00b7 Alpha2';
    }

    componentDidMount = () => {
        this._loadRegion.query(this.props.sharedProps.region);
    }

    shouldComponentUpdate = (nextProps, nextState) => {
        return (this.state.regionListTimestamp !== nextState.regionListTimestamp);
    }

    componentWillUnmount = () => {
        this._loadRegion.unmount()

        if (this._cancelToken) {
            this._cancelToken.cancel();
        }
    }

    render = () => {
        const {classes} = this.props;

        return (
            <div className={classes.view}>
                <View
                    getAccessCode={this.props.getAccessCode}
                    regionListTimestamp={this.state.regionListTimestamp}
                    regionList={this.state.regionList}
                    regionDefaultIndex={this.state.regionDefaultIndex}
                    onChangeRegion={this._handleChangeRegion}
                    onError={this.props.onError}
                />
            </div>
        );
    }

    _handleLoadMapping = (timeStamp, list, defaultIndex) => {
        this.setState({
            regionListTimestamp: timeStamp,
            regionList: list,
            regionDefaultIndex: defaultIndex,
        });
    }

    _handleChangeRegion = (index) => {
        if (this.props.setSharedProps) {
            this.props.setSharedProps({
                region: this.state.regionList[index].properties.key,
            })
        }
    }

    _processError = (error) => {
        if (error.response && error.response.status === 404) {
            this._setEmptyList();
            return;
        }

        if (this.props.onError) {
            this.props.onError(error);
        }
    }
}

Report.propTypes = {
    getAccessCode: PropTypes.func.isRequired,
    sharedProps: PropTypes.object.isRequired,
    setSharedProps: PropTypes.func,
    onError: PropTypes.func,
}

export default withStyles(styles)(Report);
